import {
    BaseReport,
    darkBarChartColor,
    darkerLightFirstColumnColor,
    darkerOrangeColor,
    generalTitleColor,
    lightRedColor,
    lightSecondColumnColor,
    PAGE_MARGIN,
    veryLightOrangeColor,
} from './BaseReport';
// lodash
import _ from "lodash";
import {orderBy, uniqBy, uniqWith} from 'lodash';
import truncateString from '../commons/truncateString';
// interfaces
import {IUsers} from '../interfaces/commons/IUsers';
import {ISchool} from '../interfaces/commons/ISchool';

/* tslint:disable:curly */

class CoverageByCourseReport extends BaseReport {

  constructor(user: IUsers, school: ISchool, dataToReport: any, logoURL: string) {
    super(user, school, dataToReport, logoURL);
  }

  public async downloadReport(): Promise<any> {
    try {

      const reportAnualCoverage = {
        content: this.buildCoverageByCoursesReport(this.dataToReport),
      };

      return await this.generateReport(reportAnualCoverage, {
        reportTitle: 'COBERTURA CURRICULAR POR CURSO - AÑO ' + this.dataToReport.year,
        firstTitle: this.dataToReport.education,
        secondTitle: 'TODOS',
        reportType: this.dataToReport.reportType,
        emissionDate: this.dataToReport.emissionDate,
        pageOrientation: 'landScape'
      });
    } catch (error) {
      console.error("ERROR EN REPORTE DE COBERTURA POR CURSOS", error);
    }
  }

  public buildCoverageByCoursesReport(dataToReport: any): any[] {
    let graphData = {};
    let data  = _.sortBy(dataToReport.data.categories, ['order', 'abrev'], 'asc').map((category) => {
      return _.sortBy(category.sections, 'name', 'asc').flatMap((sec)=> {
        graphData[category.abrev + sec.name] = {curricularesRealizados: 0, curriculares: 0, curricularesPlanificados: 0};
        return this.generalTable({
          tableContent: {
            widths: ['auto'].concat(
              category.units.map(() => '*'),
              category.units.map(() => '*'),
              [50],
            ),
            keepWithHeaderRows: 3,
            headerRows: 3,
            body: [
              [
                {
                  rowSpan: 1,
                  text: '',
                  alignment: 'center',
                  margin: [0, 7, 0, 0],
                  border: [true, true, true, false],
                  fillColor: '#F8F8F8'
                },
                {
                  colSpan: (category.units.length*2),
                  text: category.name + ' ' + sec.name,
                  margin: [0, 7, 0, 7],
                  style: ['titulo6'],
                  alignment: 'center',
                  fillColor: '#F8F8F8',
                  border: [false, true, false, true],
                },
                ...Array((category.units.length*2)-1).fill(''),
                {
                  rowSpan: 1,
                  margin: [0, 0, 0, 0],
                  text: '',
                  alignment: 'center',
                  fillColor: '#F8F8F8',
                  border: [false, true, true, true],
                  borderColor: [generalTitleColor, null, null, generalTitleColor],
                },
              ],
              [
                {
                  rowSpan: 2,
                  text: 'ASIGNATURA',
                  style: ['titulo6'],
                  alignment: 'center',
                  fillColor: '#F8F8F8',
                  margin: [0, 0, 0, 0],
                  border: [true, false, true, false],
                },
                { text: 'PLANIFICADO', color: '#F47822', colSpan: category.units.length, alignment: 'center', style: ['titulo6'], fillColor: '#F8F8F8'  }, 
                ...Array(category.units.length-1).fill(''),
                { text: 'EJECUTADO', color: '#66D485', colSpan: category.units.length, alignment: 'center',style: ['titulo6'], fillColor: '#F8F8F8' },
                ...Array(category.units.length-1).fill(''),
                {
                  rowSpan: 2,
                  margin: [0, 7, 0, 0],
                  text: 'TOTAL',
                  style: ['titulo6'],
                  alignment: 'center',
                  fillColor: '#F8F8F8',
                  border: [false, false, true, false],
                  borderColor: [generalTitleColor, null, null, darkerOrangeColor],
                },
              ],
              [
                '', 
                ...category.units.map((unit) => { return { text: unit , alignment: 'center', style: ['titulo6'], fillColor: '#F8F8F8' } }),
                ...category.units.map((unit) => { return { text: unit,  alignment: 'center', style: ['titulo6'], fillColor: '#F8F8F8'  } }),
                ''
              ],
              ..._.sortBy(sec.courses, 'orden', 'asc').map((course)=>{
                  graphData[category.abrev + sec.name].curricularesRealizados +=  course.curricularesRealizados;
                  graphData[category.abrev + sec.name].curricularesPlanificados +=  course.curricularesPlanificados;
                  graphData[category.abrev + sec.name].curriculares +=  course.prioridadPlan? course.curricularesPriorizados : course.curriculares;
                  return [
                    { text: course.name, alignment: 'left', style: ['parrafo2'],   }, 
                    ...category.units.map(
                      (unit) => {                        
                        if(course.units[unit]){
                          if(course.units[unit].totalesPlanificados>0){
                            return {
                              alignment: 'center',
                              style: ['parrafo2'],   
                              text: Math.round(course.units[unit].totalesPlanificados*100/course.units[unit].totales)+'%'                            
                            }
                          }else{
                            return {
                              alignment: 'center',
                              text : ' '
                            } 
                          }                          
                        }else{
                          return {
                            alignment: 'center',
                            style: ['parrafo2'],   
                            fillColor: generalTitleColor,
                            text: ' '
                          }
                        }                        
                      }
                    ),
                    ...category.units.map(
                      (unit) => {                        
                        if(course.units[unit]){
                          if(course.units[unit].realizados>0){
                            return {
                              alignment: 'center',    
                              style: ['parrafo2'],                        
                              text: Math.round(course.units[unit].realizados*100/course.units[unit].totales)+'%'                            
                            }
                          }else{
                            return {
                              alignment: 'center',
                              text : ' ',                              
                            } 
                          }                          
                        }else{
                          return {
                            alignment: 'center',
                            style: ['parrafo2'],
                            fillColor: generalTitleColor,
                            text: ' '
                          }
                        }                        
                      }
                    ),
                    { 
                      text: course.curricularesRealizados ? Math.round(course.curricularesRealizados*100/(course.prioridadPlan? course.curricularesPriorizados : course.curriculares))+'%' : ' ', 
                      alignment: 'center',
                      style: ['parrafo2'],   
                    }, 
                  ]
              }),
            ],
          },
          layout: {
            hLineWidth: (i: number): number => {
              return 0.1;
            },
            vLineWidth: (): number => 0.1,
          },
        });
      });
      
    })

    let curricularesStack = [];
    let realizadosStack = [];
    let planificadosStack = [];
    let graphDataValues = Object.values(graphData);
    graphDataValues.forEach((course)=>{
      let cantBase = course['curriculares']
      let cantRealizados = Math.ceil((course['curricularesRealizados']/cantBase)*100);
      let cantPlanificados = Math.ceil((course['curricularesPlanificados']/cantBase)*100);

      realizadosStack.push(cantRealizados);

      planificadosStack.push(cantPlanificados-cantRealizados);

      let total = cantRealizados + (cantPlanificados-cantRealizados) + (100-(cantPlanificados+cantRealizados))
      curricularesStack.push(100-(cantPlanificados+cantRealizados)+(100-total));

    })
    
    return [
      this.generalTable({
        tableContent: {
          layout: 'noBorders',
          widths: ['*'],
          heights: ['auto', 190], //233
          body: [
            [
              this.generalTableHeader({
                headerContent: {
                  text: 'COBERTURA CURRICULAR POR NIVEL',
                  style: ['titulo5'],
                  border: [true, true, true, false],
                },
              }),
            ],
            [
              {
                margin: [0, 0, 0, 0],
                alignment: 'center',
                image: BaseReport.buildChart(
                  200,
                  this.documentWidth - (-4 * PAGE_MARGIN),
                  {
                    padding: [0, 0, 0, 0],
                    legend: {
                      top: '50%',
                      left: '86%',
                      textStyle: {
                        fontSize: 10
                      },
                      data: [
                        'Planificado',
                        'Ejecutado'
                      ]
                    },
                    grid: {
                      top: '15%',
                      left: '-4%',
                      right: '15%',
                      bottom: '0%',
                      containLabel: true
                    },
                    xAxis: {
                      data: Object.keys(graphData)
                    },
                    yAxis: {
                      show: false
                    },
                    series: [
                      {
                        type: 'bar',
                        name: 'Ejecutado',
                        stack: 'total',
                        color: '#66D485',
                        barWidth: '70%',
                        barMinHeight: 13,
                        label: {
                          show: true,
                          color: "black",
                          fontSize: 10,
                          formatter: function(d) {
                            return Math.round((graphDataValues[d.dataIndex]['curricularesRealizados']*100)/graphDataValues[d.dataIndex]['curriculares']) + '%'
                          },
                        },
                        data: realizadosStack
                      },
                      {
                        type: 'bar',
                        name: 'Planificado',
                        stack: 'total',
                        barWidth: '60%',
                        barMinHeight: 13,
                        color: '#F47822',
                        label: {
                          show: true,
                          color: "black",
                          fontSize: 10,
                          formatter: function(d) {
                            return Math.round((graphDataValues[d.dataIndex]['curricularesPlanificados']*100)/graphDataValues[d.dataIndex]['curriculares']) + '%'
                          }
                        },
                        data: planificadosStack
                      },
                      {
                        type: 'bar',
                        name: '',
                        stack: 'total',
                        barWidth: '60%',
                        color: '#e4e4e4',
                        data: curricularesStack
                      }
                    ]
                  },
                ),
              },
            ],
          ],
        },
      }),
      ...data
    ];
  }
}

export {
  CoverageByCourseReport,
};
